class DeployerCartInfoSlider {
  constructor(element) {
    this.slider = element;
    this.track = this.slider.querySelector('.deployer-cart-drawer__info-slider-track');
    this.slides = this.slider.querySelectorAll('.deployer-cart-drawer__info-slider-slide');
    this.prevButton = this.slider.querySelector('.deployer-cart-drawer__info-slider-arrow--prev');
    this.nextButton = this.slider.querySelector('.deployer-cart-drawer__info-slider-arrow--next');
    this.autoSlideDelay = parseInt(this.slider.dataset.autoSlide) * 1000;
    this.currentIndex = 0;
    this.autoSlideInterval = null;
    this.isDragging = false;
    this.startPos = 0;
    this.currentTranslate = 0;
    this.prevTranslate = 0;

    this.init();
  }

  init() {
    if (this.slides.length <= 1) {
      this.prevButton.style.display = 'none';
      this.nextButton.style.display = 'none';
      return;
    }

    this.prevButton.addEventListener('click', () => this.slide('prev'));
    this.nextButton.addEventListener('click', () => this.slide('next'));

    // Gestion du touch sur mobile
    this.track.addEventListener('touchstart', this.touchStart.bind(this));
    this.track.addEventListener('touchmove', this.touchMove.bind(this));
    this.track.addEventListener('touchend', this.touchEnd.bind(this));

    // Gestion du défilement automatique
    if (this.autoSlideDelay > 0) {
      this.startAutoSlide();
      this.slider.addEventListener('mouseenter', () => this.stopAutoSlide());
      this.slider.addEventListener('mouseleave', () => this.startAutoSlide());
      this.slider.addEventListener('touchstart', () => this.stopAutoSlide());
      this.slider.addEventListener('touchend', () => this.startAutoSlide());
    }

    // Initialisation du snap scrolling
    this.track.style.scrollSnapType = 'x mandatory';
    this.slides.forEach(slide => {
      slide.style.scrollSnapAlign = 'center';
    });
  }

  touchStart(event) {
    this.isDragging = true;
    this.startPos = event.touches[0].clientX;
    this.prevTranslate = this.currentTranslate;
    this.track.style.transition = 'none';
  }

  touchMove(event) {
    if (!this.isDragging) return;
    
    const currentPosition = event.touches[0].clientX;
    const diff = currentPosition - this.startPos;
    this.currentTranslate = this.prevTranslate + diff;
    
    // Limiter le défilement aux limites du slider
    const maxTranslate = 0;
    const minTranslate = -(this.slides.length - 1) * 100;
    this.currentTranslate = Math.max(Math.min(this.currentTranslate, maxTranslate), minTranslate);
    
    this.track.style.transform = `translateX(${this.currentTranslate}%)`;
  }

  touchEnd() {
    this.isDragging = false;
    this.track.style.transition = 'transform 0.3s ease-in-out';
    
    // Calculer l'index le plus proche
    const slideWidth = 100;
    const currentPosition = Math.abs(this.currentTranslate);
    const targetIndex = Math.round(currentPosition / slideWidth);
    
    this.currentIndex = Math.min(targetIndex, this.slides.length - 1);
    this.currentTranslate = -(this.currentIndex * slideWidth);
    this.track.style.transform = `translateX(${this.currentTranslate}%)`;
  }

  slide(direction) {
    if (direction === 'next') {
      this.currentIndex = (this.currentIndex + 1) % this.slides.length;
    } else {
      this.currentIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
    }

    this.currentTranslate = -(this.currentIndex * 100);
    this.track.style.transform = `translateX(${this.currentTranslate}%)`;
    
    // Mettre à jour le scroll pour le mobile
    if (window.innerWidth < 750) {
      this.track.scrollTo({
        left: this.currentIndex * this.track.offsetWidth,
        behavior: 'smooth'
      });
    }
  }

  startAutoSlide() {
    if (this.autoSlideDelay > 0) {
      this.autoSlideInterval = setInterval(() => {
        this.slide('next');
      }, this.autoSlideDelay);
    }
  }

  stopAutoSlide() {
    if (this.autoSlideInterval) {
      clearInterval(this.autoSlideInterval);
    }
  }
}

customElements.define('deployer-cart-info-slider', class extends HTMLElement {
  constructor() {
    super();
    new DeployerCartInfoSlider(this);
  }
}); 